import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import {
    selectBetTotalStake,
    selectBetTotalReturns,
} from '~Betslip/selectors/betReceiptSelectors';

import {
    goBackToBetslip,
} from '~Betslip/slices/betReceiptSlice';

import {
    selectBets,
    selectTabPlacedFrom,
} from '~Betslip/selectors/betReceiptSelectors';

import {
    selectCountUserSelections,
} from '~Betslip/selectors/userSelectionsSelectors';

import {
    selectUiMode,
} from '~Betslip/selectors/uiSelectors';

import {
    setFullScreenOff,
} from '~Betslip/slices/uiSlice';

import {
    addSelectionsToBetslip,
} from '~Betslip/interface/interactions';

import formatCurrency from '~shared/utils/currencyUtils';
import { formatSelectionsToRetain } from '~Betslip/utils/selectionFormatters';

import {
    getUserTaxOnReturns,
} from '~shared/utils/user';

import { setSiteScrollDisabled } from '~spa/Utils/WrapperIntegration/Ucf';

const ReceiptCTAs = () => {
    const [ t ] = useTranslation();
    const dispatch = useDispatch();

    const totalStake = useSelector(selectBetTotalStake);
    const potentialReturns = useSelector(selectBetTotalReturns);
    const bets = useSelector(selectBets);
    const tabPlacedFrom = useSelector(selectTabPlacedFrom);
    const countUserSelections = useSelector(selectCountUserSelections);
    const uiMode = useSelector(selectUiMode);
    const tax = getUserTaxOnReturns();
    const taxForDisplay = tax * 100;
    const taxDiscount = tax * Number(potentialReturns);
    const discountDisplay = isNaN(taxDiscount) ? '' : ` (${formatCurrency(taxDiscount)})`;

    const continueClickHandler = () => {
        if (countUserSelections === 0 && uiMode === 'baby') {
            dispatch(setFullScreenOff());
            setSiteScrollDisabled(false);
        }
        dispatch(goBackToBetslip());
    };

    const retainClickHandler = () => {
        const successfulBets = bets.filter(bet => bet.success);
        if (successfulBets.length > 0) {
            const {
                selectionsToRetain,
                selectionFlags,
            } = formatSelectionsToRetain(successfulBets);

            addSelectionsToBetslip(selectionsToRetain, tabPlacedFrom, selectionFlags);
        }
        dispatch(goBackToBetslip());
    };

    const hasAnyFreebet = bets.some(bet => bet.free_bet_id);

    return (
        <>
            <div className="fullslip__ctas-receipt">
                <div className="fullslip__total-stake">
                    <span>{t('betslip.total_stake')}:</span>
                    <span>
                        {formatCurrency(totalStake)}
                        {
                            hasAnyFreebet
                            ? <span className="fullslip__total-stake-freebet"></span>
                            : null
                        }
                    </span>
                </div>
                <div className="fullslip__total-returns">
                    <span>{t('betslip.potential_returns')}:</span>
                    <span>{formatCurrency(potentialReturns)}</span>
                </div>
                <div className="fullslip__receipt-buttons">
                    <div
                        className="fullslip__retain-button"
                        data-spectate-product="new-betslip-receipt;retain-selections"
                        onClick={retainClickHandler}
                    >
                        {t('betslip.retain_selections')}
                    </div>
                    <div
                        className="fullslip__continue-button"
                        data-spectate-product="new-betslip-receipt;continue"
                        onClick={continueClickHandler}
                    >
                        {t('betslip.continue')}
                    </div>
                </div>
            </div>
            {
                tax
                ? <div className="fullslip__tax-message fullslip__tax-message--receipt">
                    {t('betslip.tax_on_return_message', {
                        tax: taxForDisplay,
                        discount: discountDisplay,
                    })}
                </div>
                : null
            }
        </>
    );
};

export default ReceiptCTAs;
